import { useState, useEffect, useLayoutEffect } from "react";
import { makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { useSelector } from "react-redux";
import UtilService from "../../../../../../../helper/service";

const useStyles = makeStyles(() => ({
  commentRoot: {
    display: "flex",
    width: "100%",
    minHeight: 400,
    position: "relative",
  },
  container: {
    minWidth: 800,
  },
  title: {
    minWidth: 100,
    background: "#fff",
    padding: "9px 12px",
    borderRadius: 12,
    borderTopLeftRadius: 0,
    border: '1px solid rgba(0, 0, 0, 0.2)',
    // boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
    color: "#0179EE",
    fontFamily: "roboto-regular",
    fontSize: 12,
  },

  textBlack: {
    color: "#323232",
  },

  textEllipsis: {
    maxWidth: "100%",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    // WebkitLineClamp: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    overflowWrap: "break-word",
  },
  drag_title: {
    minWidth: 100,
    padding: "4px 10px",
    borderRadius: 12,
    borderTopLeftRadius: 0,
    color: "#0179EE",
    fontFamily: "roboto-regular",
    fontSize: 12,
    marginLeft: -4,
  },
  box: {
    width: 30,
    height: 20,
    zIndex: 0,
    background: "#fff",
    padding: 4,
    border: '1px solid rgba(0, 0, 0, 0.2)',
    // boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
    borderTopRightRadius: 12,
    borderTopLeftRadius: 12,
  },
  hidden: {
    width: 27,
    height: 5,
    background: "#fff",
    position: "absolute",
    left: 1.6,
    marginTop: -3,
    zIndex: 0,
  },
  resizable: {
    position: "relative",
    top: 0,
  },
  bar: {
    width: "100%",
    height: 24,
    zIndex: -1,
    position: "absolute",
    background: "#e5f1fe",
  },
  times: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    fontSize: 12,
    fontFamily: "roboto-bold",
    marginBottom: -15,
  },
  iconRBox: {
    padding: 5,
    display: "flex",
    justifyContent: "flex-start",
    marginTop: -25,
  },
  iconLBox: {
    padding: 5,
    display: "flex",
    justifyContent: "flex-end",
    marginTop: -18,
    cursor: "pointer",
  },
  description: {
    padding: "6px 0",
    background: "#fff",
    paddingBottom: 18,
    boxShadow: "0 3px 4px rgba(0, 0, 0, 0.1)",
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
  },
  textField: {
    "& .MuiInputBase-root": {
      color: "#0179EE",
      fontFamily: "roboto-regular",
      fontSize: 12,
      marginTop: -4,
      background: "#e5f1fe",
      padding: "5px",
    },
  },
  iconDone: {
    position: "absolute",
    zIndex: 100,
    cursor: "pointer",
    color: "#1db859",
    margin: "-2px 0 0 1px",
  },
}));

function MarkerSection(props: any) {
  const classes = useStyles();
  const { userPreferences, module4Settings } = useSelector((state: any) => state.creatorOnBoarding);
  const { module4Data } = userPreferences;

  const { analyze } = module4Data.value;

  const { lineStep } = props;
  const { graphZoom, analyseStart, analyseEnd } = module4Settings;
  const { agenda_markers } = analyze;

  const start_at = Math.floor(analyseStart);
  const DRAGGABLE_HEIGHT = 90;

  const [curDragX] = useState(0);
  const [curDraggingId] = useState(-1);
  const [editNoteContainerWidth, setEditNoteContainerWidth] = useState(0);

  const start = 0;
  const end = analyseEnd - analyseStart - 1;
  const NOTE_MIN_WIDTH = 100;

  useLayoutEffect(() => {
    window.addEventListener("resize", updateEditNoteWidth);
  });

  useEffect(() => {
    updateEditNoteWidth();
  }, [graphZoom]);

  const comments = agenda_markers.filter((item: any) => item.marker_type !== 1 && item.start_marker_at !== "0")

  const updateEditNoteWidth = () => {
    const timer1 = setTimeout(() => {
      const commentContainer = document.getElementById("comment_container");
      if (!commentContainer) return;
      setEditNoteContainerWidth(commentContainer.offsetWidth);
    }, 100);
    return () => {
      clearTimeout(timer1);
    };
  };

  const getNoteWidth = (item: any) => {
    let noteWidth =
      ((item.end_marker_at - item.start_marker_at) * lineStep) /
      Math.pow(graphZoom, 2);
    const noteStartPosition = getEditStartXPosition(item);
    const offset = noteStartPosition + noteWidth - editNoteContainerWidth;
    if (offset > 0) noteWidth -= offset;

    return Math.max(noteWidth, NOTE_MIN_WIDTH);
  };

  const getEditStartXPosition = (item: any) => {
    const xPosition =
      ((parseInt(item.start_marker_at) - start_at - start) /
        Math.pow(graphZoom, 2)) *
      lineStep;
    return xPosition;
  };

  const getStartXPosition = (item: any) => {
    return getEditStartXPosition(item);
  };

  return (
    <div style={{ position: "relative", marginTop: 20 }}>
      <div
        className={classes.commentRoot}
        id={"comment_container"}
        style={{ height: DRAGGABLE_HEIGHT * 7 }}
      >
        {comments
          .filter(
            (item: any) =>
              (item.start_marker_at - start_at - start >= 0 && item.end_marker_at - start_at - start - end <= 1)
          )
          .map((item: any, key: number) => (
            <div
              key={key}
              style={{
                position: "absolute",
                width: 0,
                left: `${getStartXPosition(item)}px`,
                top: `${(item.marker_type - 2) * 90}px`,
              }}
            >
              <>
                <div className={classes.box} style={{ top: -22, position: 'absolute', zIndex: 0 }}>
                  <img
                    src={"/assets/icons/liveanalysis/pencil-ruler-grid-black.svg"}
                    alt={"img"}
                  />
                </div>
                <div className={classes.hidden} style={{ zIndex: 1 }}></div>
              </>
              <div>
                <div className="handle">
                  <div>
                    <div
                      className={clsx(classes.title, classes.textBlack)}
                      style={{
                        width: getNoteWidth(item),
                      }}
                    >
                      <div className={classes.textEllipsis}>
                        <span>{item.marker_title}</span>
                      </div>
                    </div>
                  </div>

                  {curDraggingId === Number(item.marker_id) && (
                    <div
                      className={clsx(classes.times, classes.drag_title)}
                      style={{
                        width:
                          ((item.end_marker_at - item.start_marker_at) /
                            Math.pow(graphZoom, 2)) *
                          lineStep,
                      }}
                    >
                      <span className={classes.textBlack}>
                        {UtilService.getStartTimeLabel(
                          item.start_marker_at -
                          start_at +
                          curDragX * Math.pow(graphZoom, 2),
                          1,
                          0
                        )}
                      </span>
                      <span className={classes.textBlack}>
                        {UtilService.getEndTimeLabel(
                          item.start_marker_at -
                          start_at +
                          curDragX * Math.pow(graphZoom, 2),
                          item.end_marker_at -
                          start_at +
                          curDragX * Math.pow(graphZoom, 2),
                          1,
                          0
                        )}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default MarkerSection;
